export const FREE_TEXT_VALUE_DEFINITION_ID : string| undefined = process.env.REACT_APP_FREE_TEXT_VALUE_DEFINITION_ID